import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Add } from "iconsax-react";
import DBModal from "../../component/global/DBModal";
import { DBButton } from "../../DBComponents/DBButton";
import { phoneValidator } from "../helperFunctions";

const normalizeDigits = (value = "") =>
    value
        .replace(/[۰-۹]/g, (digit) => "۰۱۲۳۴۵۶۷۸۹".indexOf(digit))
        .replace(/[٠-٩]/g, (digit) => "٠١٢٣٤٥٦٧٨٩".indexOf(digit));

const normalizePhone = (value) => {
    let phone = normalizeDigits(value).replace(/[\s-]/g, "");
    if (/^\+989\d{9}$/.test(phone)) {
        phone = `0${phone.slice(3)}`;
    } else if (/^9\d{9}$/.test(phone)) {
        phone = `0${phone}`;
    }
    return phone;
};

export default function ShareSmsModal({
    show,
    onHide,
    preview,
    loading,
    error,
    onSend,
}) {
    const { t } = useTranslation();
    const [draft, setDraft] = useState("");
    const [phones, setPhones] = useState([]);
    const [phoneError, setPhoneError] = useState("");

    useEffect(() => {
        if (!show) {
            setDraft("");
            setPhones([]);
            setPhoneError("");
        }
    }, [show]);

    const addPhone = () => {
        const phone = normalizePhone(draft);
        if (phoneValidator(phone) !== true) {
            setPhoneError(t("contents.share.sms.phoneErr"));
            return;
        }
        if (phones.includes(phone)) {
            setDraft("");
            setPhoneError("");
            return;
        }
        if (phones.length >= 10) {
            setPhoneError(t("contents.share.sms.limit"));
            return;
        }
        setPhones((current) => [...current, phone]);
        setDraft("");
        setPhoneError("");
    };

    return (
        <DBModal
            minWidth={400}
            show={show}
            onHide={onHide}
            className="share-sms-modal"
        >
            <DBModal.Header
                closeBtn={onHide}
                title={t("contents.share.sms.title")}
            />
            <DBModal.Content>
                <p className="share-sms-modal__lead">
                    {t("contents.share.sms.lead")}
                </p>
                <pre className="share-sms-modal__preview">{preview}</pre>
                <label htmlFor="share-sms-phone">
                    {t("contents.share.sms.phones")}
                </label>
                <div className="share-sms-modal__add">
                    <input
                        id="share-sms-phone"
                        type="tel"
                        inputMode="numeric"
                        dir="ltr"
                        placeholder="09123456789"
                        value={draft}
                        onChange={(event) => {
                            setDraft(event.target.value);
                            setPhoneError("");
                        }}
                        onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === ",") {
                                event.preventDefault();
                                addPhone();
                            }
                        }}
                    />
                    <button type="button" onClick={addPhone}>
                        <Add size={18} />
                        {t("contents.share.sms.add")}
                    </button>
                </div>
                {phones.length ? (
                    <ul className="share-sms-modal__chips">
                        {phones.map((phone) => (
                            <li key={phone}>
                                <span dir="ltr">{phone}</span>
                                <button
                                    type="button"
                                    aria-label={t("contents.share.sms.remove")}
                                    onClick={() =>
                                        setPhones((current) =>
                                            current.filter((row) => row !== phone)
                                        )
                                    }
                                >
                                    ×
                                </button>
                            </li>
                        ))}
                    </ul>
                ) : null}
                {phoneError || error ? (
                    <p className="share-sms-modal__error" role="alert">
                        {phoneError || error}
                    </p>
                ) : null}
                <DBButton
                    loading={loading}
                    disabled={loading}
                        onClick={() => {
                            let next = phones;
                            if (!next.length) {
                                const phone = normalizePhone(draft);
                                if (phoneValidator(phone) !== true) {
                                    setPhoneError(
                                        t("contents.share.sms.phoneErr")
                                    );
                                    return;
                                }
                                next = [phone];
                                setPhones(next);
                                setDraft("");
                            }
                            onSend(next);
                        }}
                >
                    {t("contents.share.sms.submit")}
                </DBButton>
            </DBModal.Content>
        </DBModal>
    );
}
